import type { TenantBundle } from "@crosure/tenant-runtime";

import { brand } from "./brand.js";
import { config } from "./config.js";
import { theme } from "./theme.js";

const bundle: TenantBundle = {
  meta: {
    code: "green-shield-insurance-brokers",
    name: "Green Shield Insurance Brokers",
    country: "sa",
    locale: "ar-SA",
  },
  theme,
  brand,
  config,
  // Optional, fill in when needed:
  // copy: { ... },
  // components: { Hero: MyHero, Footer: MyFooter },
  // routes: { mode: "merge" },     // default — see §5b of the spec
  // auth: {                         // declare session topology — see §5c
  //   label: "Single session",
  //   sessions: [{ name: "session", scope: "/", ttlSeconds: 28800 }],
  // },
};

export default bundle;
